import { MealEntry } from '@/graphql/custom-types';
import {
  GetMealsByFiltersDocument,
  GetMealsByIdsDocument,
} from '@/graphql/generated-types';
import { apolloClient } from '@/utils/apollo';
import { toAPIDate } from '@/utils/date-fns';
import SentryGraphQLError from '@/utils/exceptions/SentryGraphQLError';

const getMealRange = async (
  departmentId: string,
  dateTo: Date
): Promise<MealEntry[]> => {
  const response = await apolloClient.query({
    query: GetMealsByFiltersDocument,
    variables: {
      filter: {
        departments: [departmentId],
      },
      dateFrom: toAPIDate(new Date()),
      dateTo: toAPIDate(dateTo),
      timezone: 'Europe/Copenhagen',
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data?.meal?.getMealsByFilters) {
    return response.data.meal?.getMealsByFilters;
  }

  throw new SentryGraphQLError(`api.meal.getMealRange`, response);
};

const getMealById = async (mealId: string) => {
  const response = await apolloClient.query({
    query: GetMealsByIdsDocument,
    variables: {
      ids: [mealId],
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  if (response.data.meal?.getMeals) {
    const meals = response.data.meal.getMeals;
    if (meals.length > 0) {
      return meals[0];
    }
  }

  throw new SentryGraphQLError(`api.meal.getMealById`, response);
};

export default {
  getMealRange,
  getMealById,
};
